
import { useEffect, useState } from "react";
import {responseMsg} from "../../common/ResponseMsg";
import UserEditModal from "./UserEditModal";
import UserAddModal from "./UserAddModal";
import ManagementPage from '../../../shared/components/ManagementPage';
import ManageButton from '../../../shared/components/ManageButton';
import Text from '../../../shared/components/Text';
import Input from '../../../shared/components/Input';
import Flex from '../../../shared/components/Flex';
import Card from '../../../shared/components/Card';
import GridInfo from '../../../shared/components/GridInfo';
import Spacer from '../../../shared/components/Spacer';
import ScrollModal from '../../common/ScrollModal';
import useDevice from '../../../shared/hooks/useDevice';
import Padding from '../../../shared/components/Padding';
import CommonSelect from '../../../shared/components/CommonSelect';
import AgGridTable from '../../common/AgGridTable';
import { useAlert } from '../../../shared/components/AlertProvider';
import { addTooltipField } from '../../../shared/utils/gridTitleUtil';

function User({name}) {
    const [render, setRender] = useState(false);
    const [searchObj, setSearchObj] = useState({req: {encodedNm: ""}});
    const [users, setUsers] = useState();
    const [updateModal, setUpdateModal] = useState({});
    const [addModal, setAddModal] = useState({});
    const [pagination, setPagination ] = useState();
    const device = useDevice();
    const isMobile = device !== 'desktop'
    const [useYn, setUseYn] = useState("Y");
    const showAlert = useAlert();
    const [ selectedUser, setSelectedUser ] = useState({});

    const useYnOption = [
        {text: "사용", value: "Y"},
        {text: "미사용", value: "N"}
    ]

    const rendering = () => {
        closeUpdateModal();
        closeAddModal();
        setRender(!render);
    }

    // 컬럼 기본 옵션
    const [columnDefs, setColumnDefs] = useState(addTooltipField(
        [
            { headerName: '번호', field: 'rowNo', width: 65},
            { headerName: '아이디', field: 'userId', sortable: false, width: 200, cellStyle: { textAlign: "left" }},
            { headerName: '사용자명', field: 'userNm', sortable: false, width: 200, cellStyle: { textAlign: "left" }},
            { headerName: '소속', field: 'allianceName', sortable: false, width: 200, cellStyle: { textAlign: "left" }},
            { headerName: '부서', field: 'department', sortable: false, width: 200, cellStyle: { textAlign: "left" }},
            { headerName: '전화번호', field: 'cellNo', sortable: false, width: 150},
            { headerName: '이메일', field: 'email', sortable: false, width: 220, cellStyle: { textAlign: "left" }},
            { headerName: '등록일', field: 'createDtm', sortable: false, width: 180, cellStyle: { textAlign: "left" }},
            { headerName: '수정일', field: 'updateDtm', sortable: false, width: 180, cellStyle: { textAlign: "left" }},
            { headerName: '비고', field: 'comment', sortable: false, width: 220, cellStyle: { textAlign: "left" }},
        ]
    ));

    // 모달 (등록)
    const openAddModal = (cell) => {

        setAddModal({
            ...addModal,
            open: true,
            close: closeAddModal,
            main: <UserAddModal
                rendering={rendering}
            />
        });
    };

    const closeAddModal = () => {

        setAddModal({
            ...addModal,
            open : false,
        });
    };

    // 모달 (수정)
    const openUpdateModal = (cell) => {

        setUpdateModal({
            ...updateModal,
            open: true,
            close: closeUpdateModal,
            main: <UserEditModal
                user={cell.data}
                rendering={rendering}
            />
        });
    };

    const closeUpdateModal = () => {

        setUpdateModal({
            ...updateModal,
            open : false,
        });
    };

    const apiGetUserList = (page) => {
        let url = '/api/system/users?'
        const pagingSize = 20;
        page = page ?? 1;

        if (page) {
            url += `page=${page-1}&`
            url += `size=${pagingSize}&`
        }

        if(searchObj) {
            Object.keys(searchObj.req).forEach(ele => {
                if (searchObj.req[ele]) {
                    url += `${ele}=${searchObj.req[ele]}&`
                }
            })

            url += `useYn=${useYn}&`;
            
            fetch(url ,{
                method:"GET"
            })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setUsers(json.data.map((ele,idx) => ({rowNo:idx+1, ...ele})) )
                    setPagination(json.pagination);
    
                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
        } 
    }

    const search = () => {
        const userId = document.getElementById("userId")?.value.trim() ?? "";
        const userNm = document.getElementById("userNm")?.value.trim() ?? "";
        setSearchObj({req: {
            userId,
            userNm,
        }})
    }

    useEffect(() => {
      apiGetUserList(1);
      
    },[render,searchObj, useYn])

    return (
        <ManagementPage
            title='사용자관리'
            actions={
                <>
                    <ManageButton
                        onClick={search} 
                        btnType='search'
                    />
                    <ManageButton onClick={openAddModal} btnType='regist'/>
                </>
            }
            searchArea={
                <>
                    <Flex flexDirection={isMobile ? 'column' : 'row'} gap={isMobile ? 8 : 30}>
                        <Flex alignItems='center'>
                            <Text size={"sm"} style={{width: "70px", flexShrink: 0}}>아이디</Text>
                            <Input 
                                id='userId' 
                                fullWidth={isMobile} 
                                name="userId" 
                                placeholder='아이디를 입력해 주세요' 
                                style={{flex: 1}} 
                                maxLength={200} 
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        search();
                                    } 
                                }}
                                autoFocus
                            />
                        </Flex>
                            
                        <Flex alignItems='center'>
                            <Text size={"sm"} style={{width: "70px", flexShrink: 0}}>사용자명</Text>
                            <Input 
                                id='userNm' 
                                fullWidth={isMobile} 
                                name="userNm" 
                                placeholder='사용자명을 입력해 주세요' 
                                style={{flex: 1}} 
                                maxLength={200} 
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        search();
                                    } 
                                }}
                            />
                        </Flex>

                        <div style={{ width: isMobile ? "auto" : "324px" }}>
                            <CommonSelect label='사용여부' fullWidth value={useYn} data={useYnOption} onChange={setUseYn}/>
                        </div>
                    </Flex>
                </>
            }
        >
            <div className="page_contents">
                <Card fullWidth style={{ flex: 1, display: 'flex' }}>
                    <Padding paddingX={10} paddingY={15} style={{ flex: 1, display: "flex", flexDirection: "column"}}>
                        <GridInfo title='사용자 목록' width={490}
                                content='항목을 클릭하면 선택한 권한의 화면별 권한 목록이 오른쪽 목록에 표시됩니다.
                                            항목을 더블클릭하면 선택한 권한을 수정하는 화면이 열립니다.' />
                        <Spacer direction='vertical' size={15} />
                        <AgGridTable
                            rowData={users}
                            columnDefs={columnDefs}
                            onRowClicked={(row) => {
                                setSelectedUser(row.data);
                            }}
                            onRowDoubleClicked={(params) => {
                                openUpdateModal(params);
                            }}
                            
                            selectedRow={selectedUser}
                            selectedKey="userId"

                            tooltipShowDelay={0}
                            tooltipHideDelay={2000}
                            onPageChange={apiGetUserList}
                            pagination={pagination}
                        />
                    </Padding>
                </Card>
            </div>
            
            <ScrollModal
                headerText="사용자 등록"
                size={"595px"}
                modal={addModal}
            >
            </ScrollModal>

            <ScrollModal
                
                headerText="사용자 수정"
                size={"595px"}
                modal={updateModal}
            >
            </ScrollModal>
        </ManagementPage>
    );
}

export default User;